export default {
  languages: state => state.languages,
  newContentAvailable: state =>
    state.SWRegistrationForNewContent !== null &&
    state.SWRegistrationForNewContent !== undefined,
  appTitle: state => state.appTitle,
  loading: state => state.loading,
  error: state => state.error,
  snackbar: state => state.snackbar,
  searchString: state => state.searchString,
  currentPageNumber: state => state.currentPageNumber,
  selectedLanguage: state => state.selectedLanguage,
  availableApplications: state => state.availableApplications,
  appIcons: state => state.appIcons,
  theme: state => state.theme,
  vehicleNumberSearchString: state => state.vehicleNumberSearchString,
  quickActions: state => state.quickActions
}
